// "Continue with Apple, Google or phone": opens Clerk's sign-in. ClerkBridge finishes the InstaPass sign-in.
import React from "react";
import { useClerk } from "@clerk/react";

export default function ClerkSignInButton({ onOpen }) {
  const clerk = useClerk();
  return (
    <button
      type="button"
      className="social-btn google-btn"
      onClick={() => {
        onOpen?.();
        clerk.openSignIn({ forceRedirectUrl: window.location.href, signUpForceRedirectUrl: window.location.href });
      }}
    >
      <span>Continue with Apple, Google or phone</span>
    </button>
  );
}
